import { render, staticRenderFns } from "./wechatFeePercentSetting.vue?vue&type=template&id=a6f6caae&scoped=true"
import script from "./wechatFeePercentSetting.vue?vue&type=script&lang=ts"
export * from "./wechatFeePercentSetting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f6caae",
  null
  
)

export default component.exports